/**
 * Created by Kirill Mashchenko on 07.07.2018.
 */

/**
 * @class pm.Task for carrying objects on needed elements.
 * @implements pm.Task
 * @constructor
 * @param {pm.AbstractLevel} level
 */
pm.data.TrainTask = pm.Task.extend(/** @ends pm.data.TrainTask# */{
	typeName: "TrainTask",

	ctor: function(level)
	{
		this._super(level);
	},

	getNotCompletedObjects: function (mapIndex)
	{
		var map = this._level.maps[mapIndex];

		var completed = true;

		var retArray = [];

		var point = cc.p();
		var type = 0;
		var elementObjectType = 0;

		for(var i = 0; i < map._trainTargetElements.length; ++i)
		{
			point = map._trainTargetElements[i].point;
			type = map._trainTargetElements[i].type;

			if(map.element(point).getObjectCount() === 1)
			{
				elementObjectType = map.element(point).getObjectByKeyIndex(0).getType();

				switch(type)
				{
					case TrainMapElementType.CarTarget:
						completed = elementObjectType === pm.TrainLevelModule.ObjectTypes.TrainCar;
						break;

					case TrainMapElementType.BarrelTarget:
						completed = elementObjectType === pm.TrainLevelModule.ObjectTypes.TrainBarrel;
						break;

					case TrainMapElementType.CommonTarget:
						break;
				}
			}
			else
			{
				completed = false;
			}

			if(!completed)
				retArray.push(map.element(point));
		}

		return retArray;
	},

	moveDown: function(mapIndex)
	{
		var map = this._level.maps[mapIndex];

		for (var i = 0; i < map._trainTargetElements.length; ++i)
			map._trainTargetElements[i].point.y--;
	},

	moveUp: function(mapIndex)
	{
		var map = this._level.maps[mapIndex];

		for (var i = 0; i < map._trainTargetElements.length; ++i)
			map._trainTargetElements[i].point.y++;
	},

	moveRight: function(mapIndex)
	{
		var map = this._level.maps[mapIndex];

		for (var i = 0; i < map._trainTargetElements.length; ++i)
			map._trainTargetElements[i].point.x--;
	},

	moveLeft: function(mapIndex)
	{
		var map = this._level.maps[mapIndex];

		for (var i = 0; i < map._trainTargetElements.length; ++i)
			map._trainTargetElements[i].point.x++;
	}
});
